/**
 * Shared geometry for the wheelchair / universal-access pictogram.
 */

/** SVG view box for wheelchair icons. */
export const WHEELCHAIR_ICON_VIEW_BOX = "0 0 16 16";

/**
 * Filled universal-access path (16×16).
 * Source: Bootstrap-style pictogram; fill color applied at render time.
 */
export const WHEELCHAIR_ICON_PATH =
    "M12 3a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m-.663 2.146a1.5 1.5 0 0 0-.47-2.115l-2.5-1.508a1.5 1.5 0 0 0-1.676.086l-2.329 1.75a.866.866 0 0 0 1.051 1.375L7.361 3.37l.922.71-2.038 2.445A4.73 4.73 0 0 0 2.628 7.67l1.064 1.065a3.25 3.25 0 0 1 4.574 4.574l1.064 1.063a4.73 4.73 0 0 0 1.09-3.998l1.043-.292-.187 2.991a.872.872 0 1 0 1.741.098l.206-4.121A1 1 0 0 0 12.224 8h-2.79zM3.023 9.48a3.25 3.25 0 0 0 4.496 4.496l1.077 1.077a4.75 4.75 0 0 1-6.65-6.65z";
